import {useMemo} from 'react';

import {useTranslation} from 'react-i18next';

import {
  PasswordValidationCodes,
  VerifyPasswordState,
} from '@/app/shared-components/VerifyPassword/models/constants';
import {IVerifyPassword} from '@/app/shared-components/VerifyPassword/models/interface';

// Builds the static list of password rules shown by the VerifyPassword
// component, translated on mount.
export function usePasswordVerifyList(): IVerifyPassword[] {
  const {t} = useTranslation();

  return useMemo(
    () => [
      {
        code: PasswordValidationCodes.MIN_LENGTH,
        description: t('password_component.length'),
        state: VerifyPasswordState.NONE,
        isEnabled: true,
      },
      {
        code: PasswordValidationCodes.NUMBER_UPPER_LOWER,
        description: t('password_component.characters'),
        state: VerifyPasswordState.NONE,
        isEnabled: true,
      },
      {
        code: PasswordValidationCodes.SPECIAL_CHARACTER,
        description: t('password_component.special_character'),
        state: VerifyPasswordState.NONE,
        isEnabled: true,
      },
      {
        code: PasswordValidationCodes.EXACT_MATCH,
        description: t('password_component.match'),
        state: VerifyPasswordState.NONE,
        isEnabled: true,
      },
    ],
    [t],
  );
}
